import { BrowserRouter } from 'react-router-dom'
import StatsigComponent from './statsig-component'
import * as serviceWorker from './serviceWorker'
import TagManager from 'react-gtm-module'
import { AppConfigProvider, buildAppTheme } from '@/shared/ui'
import './styles/index.less'
import './styles/beamer-overrides.css'
import Main from './Main/Scenes'
import { I18nextProvider } from 'react-i18next'
import i18n from './config/i18n'
import { AuthProvider } from './auth/Auth.context'
import { useAuth } from './auth/Auth.hook'
import { WrapperAuthProvider } from './auth/providers'
import { LoadingProvider } from './Main/Contexts/LoadingContext'

const GTM_ID = import.meta.env.VITE_GTM_ID
if (GTM_ID) {
  const tagManagerArgs = {
    gtmId: GTM_ID
  }
  TagManager.initialize(tagManagerArgs)
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('../firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Registration successful, scope is:', registration.scope)
    })
    .catch((err) => {
      console.log('Service worker registration failed, error:', err)
    })
}

const ThemedConfigProvider = ({ children }) => {
  const { userInfo } = useAuth()
  const primaryColor = userInfo?.client?.styles?.['@primary-color']
  return <AppConfigProvider theme={buildAppTheme(primaryColor)}>{children}</AppConfigProvider>
}

const App = () => (
  <WrapperAuthProvider>
    <AuthProvider>
      <StatsigComponent>
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <LoadingProvider>
              <ThemedConfigProvider>
                <Main />
              </ThemedConfigProvider>
            </LoadingProvider>
          </I18nextProvider>
        </BrowserRouter>
      </StatsigComponent>
    </AuthProvider>
  </WrapperAuthProvider>
)

export default App

serviceWorker.unregister()
